// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file common/user.proto (package common, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AccountMessage } from "./billing_pb";
import { file_common_billing } from "./billing_pb";
import type { AppType } from "./common_pb";
import { file_common_common } from "./common_pb";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file common/user.proto.
 */
export const file_common_user: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_billing, file_common_common, file_google_protobuf_struct]);

/**
 * @generated from message common.UtmInfoMessage
 */
export type UtmInfoMessage = Message<"common.UtmInfoMessage"> & {
  /**
   * @generated from field: optional string utm_source = 1;
   */
  utmSource?: string;

  /**
   * @generated from field: optional string utm_medium = 2;
   */
  utmMedium?: string;

  /**
   * @generated from field: optional string utm_campaign = 3;
   */
  utmCampaign?: string;

  /**
   * @generated from field: optional string utm_term = 4;
   */
  utmTerm?: string;

  /**
   * @generated from field: optional string utm_content = 5;
   */
  utmContent?: string;

  /**
   * @generated from field: optional string referrer = 6;
   */
  referrer?: string;

  /**
   * @generated from field: optional string click_id = 7;
   */
  clickId?: string;
};

/**
 * Describes the message common.UtmInfoMessage.
 * Use `create(UtmInfoMessageSchema)` to create a new message.
 */
export const UtmInfoMessageSchema: GenMessage<UtmInfoMessage> = /*@__PURE__*/
  messageDesc(file_common_user, 0);

/**
 * @generated from message common.UserMessage
 */
export type UserMessage = Message<"common.UserMessage"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: optional string first_name = 3;
   */
  firstName?: string;

  /**
   * @generated from field: optional string last_name = 4;
   */
  lastName?: string;

  /**
   * @generated from field: optional string promo_code = 5;
   */
  promoCode?: string;

  /**
   * @generated from field: common.UserStatus status = 6;
   */
  status: UserStatus;

  /**
   * @generated from field: repeated common.UserRole roles = 7;
   */
  roles: UserRole[];

  /**
   * @generated from field: optional string email_verified_at = 8;
   */
  emailVerifiedAt?: string;

  /**
   * @generated from field: optional string last_login = 9;
   */
  lastLogin?: string;

  /**
   * @generated from field: optional string country_code = 10;
   */
  countryCode?: string;

  /**
   * @generated from field: optional string timezone = 11;
   */
  timezone?: string;

  /**
   * @generated from field: optional string language = 12;
   */
  language?: string;

  /**
   * @generated from field: optional string referral_code = 13;
   */
  referralCode?: string;

  /**
   * @generated from field: optional string created_at = 14;
   */
  createdAt?: string;

  /**
   * @generated from field: optional string date_of_birth = 15;
   */
  dateOfBirth?: string;

  /**
   * @generated from field: optional string referred_by_code = 16;
   */
  referredByCode?: string;

  /**
   * @generated from field: bool subscribe_for_news = 17;
   */
  subscribeForNews: boolean;

  /**
   * @generated from field: bool subscribe_for_withdrawals = 18;
   */
  subscribeForWithdrawals: boolean;

  /**
   * @generated from field: bool subscribe_for_deposits = 19;
   */
  subscribeForDeposits: boolean;

  /**
   * @generated from field: bool halal_enabled = 20;
   */
  halalEnabled: boolean;

  /**
   * @generated from field: bool is_onboarded = 21;
   */
  isOnboarded: boolean;

  /**
   * @generated from field: optional common.AccountMessage account = 22;
   */
  account?: AccountMessage;

  /**
   * @generated from field: optional string updated_at = 23;
   */
  updatedAt?: string;

  /**
   * @generated from field: repeated string tags = 24;
   */
  tags: string[];

  /**
   * @generated from field: optional string date_format = 25;
   */
  dateFormat?: string;

  /**
   * @generated from field: optional common.TimeFormat time_format = 26;
   */
  timeFormat?: TimeFormat;

  /**
   * @generated from field: optional string phone = 27;
   */
  phone?: string;

  /**
   * @generated from field: optional string nickname = 28;
   */
  nickname?: string;

  /**
   * @generated from field: optional string avatar_url = 29;
   */
  avatarUrl?: string;

  /**
   * @generated from field: bool totp_enabled = 30;
   */
  totpEnabled: boolean;

  /**
   * @generated from field: bool name_set_by_user = 31;
   */
  nameSetByUser: boolean;

  /**
   * @generated from field: common.KycStatus kyc_status = 32;
   */
  kycStatus: KycStatus;

  /**
   * @generated from field: bool totp_on_login = 33;
   */
  totpOnLogin: boolean;

  /**
   * @generated from field: bool totp_on_withdraw = 34;
   */
  totpOnWithdraw: boolean;

  /**
   * @generated from field: optional string withdrawal_blocked_until = 35;
   */
  withdrawalBlockedUntil?: string;

  /**
   * @generated from field: optional int32 outperforming_percent = 36;
   */
  outperformingPercent?: number;

  /**
   * @generated from field: bool is_fake = 37;
   */
  isFake: boolean;

  /**
   * @generated from field: bool subscribe_for_security = 38;
   */
  subscribeForSecurity: boolean;

  /**
   * @generated from field: bool subscribe_for_common = 39;
   */
  subscribeForCommon: boolean;

  /**
   * @generated from field: bool is_partner = 40;
   */
  isPartner: boolean;

  /**
   * @generated from field: bool kyc_required = 41;
   */
  kycRequired: boolean;

  /**
   * @generated from field: optional string kyc_required_reason = 42;
   */
  kycRequiredReason?: string;

  /**
   * True while withdrawals are restricted to the payout method(s) matching the
   * user's last fiat deposit (see PayoutRestrictionService). Drives the banner.
   *
   * @generated from field: bool payout_restriction_active = 43;
   */
  payoutRestrictionActive: boolean;

  /**
   * @generated from field: optional string payout_restricted_until = 44;
   */
  payoutRestrictedUntil?: string;

  /**
   * @generated from field: bool subscribe_for_stats = 45;
   */
  subscribeForStats: boolean;

  /**
   * @generated from field: bool stream_mode = 46;
   */
  streamMode: boolean;

  /**
   * @generated from field: common.OnboardingStatus onboarding_status = 47;
   */
  onboardingStatus: OnboardingStatus;

  /**
   * @generated from field: bool onboarding_deposit_pending = 48;
   */
  onboardingDepositPending: boolean;

  /**
   * @generated from field: bool deposit_recovery_shown = 49;
   */
  depositRecoveryShown: boolean;

  /**
   * @generated from field: bool partner_trade_cancel_enabled = 50;
   */
  partnerTradeCancelEnabled: boolean;
};

/**
 * Describes the message common.UserMessage.
 * Use `create(UserMessageSchema)` to create a new message.
 */
export const UserMessageSchema: GenMessage<UserMessage> = /*@__PURE__*/
  messageDesc(file_common_user, 1);

/**
 * @generated from message common.UserSettingMessage
 */
export type UserSettingMessage = Message<"common.UserSettingMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string section = 2;
   */
  section?: string;

  /**
   * @generated from field: string key = 3;
   */
  key: string;

  /**
   * @generated from field: optional google.protobuf.Struct value = 4;
   */
  value?: JsonObject;
};

/**
 * Describes the message common.UserSettingMessage.
 * Use `create(UserSettingMessageSchema)` to create a new message.
 */
export const UserSettingMessageSchema: GenMessage<UserSettingMessage> = /*@__PURE__*/
  messageDesc(file_common_user, 2);

/**
 * @generated from message common.SessionMessage
 */
export type SessionMessage = Message<"common.SessionMessage"> & {
  /**
   * @generated from field: optional string user_agent = 1;
   */
  userAgent?: string;

  /**
   * @generated from field: optional string ip = 2;
   */
  ip?: string;

  /**
   * @generated from field: optional string updated_at = 3;
   */
  updatedAt?: string;

  /**
   * @generated from field: optional bool is_current = 4;
   */
  isCurrent?: boolean;

  /**
   * @generated from field: optional string sid = 5;
   */
  sid?: string;

  /**
   * @generated from field: optional string browser = 6;
   */
  browser?: string;

  /**
   * @generated from field: optional string os = 7;
   */
  os?: string;

  /**
   * @generated from field: optional string device = 8;
   */
  device?: string;

  /**
   * @generated from field: optional string country_code = 9;
   */
  countryCode?: string;

  /**
   * @generated from field: optional string country_name = 10;
   */
  countryName?: string;
};

/**
 * Describes the message common.SessionMessage.
 * Use `create(SessionMessageSchema)` to create a new message.
 */
export const SessionMessageSchema: GenMessage<SessionMessage> = /*@__PURE__*/
  messageDesc(file_common_user, 3);

/**
 * @generated from message common.SessionDataMessage
 */
export type SessionDataMessage = Message<"common.SessionDataMessage"> & {
  /**
   * @generated from field: string sid = 1;
   */
  sid: string;

  /**
   * @generated from field: string sub = 2;
   */
  sub: string;

  /**
   * @generated from field: int64 exp = 3;
   */
  exp: bigint;

  /**
   * @generated from field: int64 iat = 4;
   */
  iat: bigint;

  /**
   * @generated from field: repeated common.UserRole roles = 5;
   */
  roles: UserRole[];

  /**
   * @generated from field: optional string email = 6;
   */
  email?: string;

  /**
   * @generated from field: optional common.AppType app = 7;
   */
  app?: AppType;

  /**
   * @generated from field: optional string user_agent = 8;
   */
  userAgent?: string;

  /**
   * @generated from field: optional string ip = 9;
   */
  ip?: string;

  /**
   * @generated from field: optional string accept_language = 10;
   */
  acceptLanguage?: string;

  /**
   * @generated from field: optional string created_at = 11;
   */
  createdAt?: string;

  /**
   * @generated from field: optional string updated_at = 12;
   */
  updatedAt?: string;
};

/**
 * Describes the message common.SessionDataMessage.
 * Use `create(SessionDataMessageSchema)` to create a new message.
 */
export const SessionDataMessageSchema: GenMessage<SessionDataMessage> = /*@__PURE__*/
  messageDesc(file_common_user, 4);

/**
 * @generated from enum common.UserRole
 */
export enum UserRole {
  /**
   * @generated from enum value: USER_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER_ROLE_CLIENT = 1;
   */
  CLIENT = 1,

  /**
   * @generated from enum value: USER_ROLE_PARTNER = 2;
   */
  PARTNER = 2,

  /**
   * @generated from enum value: USER_ROLE_ADMIN = 3;
   */
  ADMIN = 3,

  /**
   * @generated from enum value: USER_ROLE_MODERATOR = 4;
   */
  MODERATOR = 4,

  /**
   * @generated from enum value: USER_ROLE_FINANCIER = 5;
   */
  FINANCIER = 5,

  /**
   * @generated from enum value: USER_ROLE_SUPPORTER = 6;
   */
  SUPPORTER = 6,
}

/**
 * Describes the enum common.UserRole.
 */
export const UserRoleSchema: GenEnum<UserRole> = /*@__PURE__*/
  enumDesc(file_common_user, 0);

/**
 * @generated from enum common.UserStatus
 */
export enum UserStatus {
  /**
   * @generated from enum value: USER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: USER_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * @generated from enum value: USER_STATUS_SUSPENDED = 3;
   */
  SUSPENDED = 3,

  /**
   * @generated from enum value: USER_STATUS_BANNED = 4;
   */
  BANNED = 4,

  /**
   * @generated from enum value: USER_STATUS_DELETED = 5;
   */
  DELETED = 5,
}

/**
 * Describes the enum common.UserStatus.
 */
export const UserStatusSchema: GenEnum<UserStatus> = /*@__PURE__*/
  enumDesc(file_common_user, 1);

/**
 * @generated from enum common.TimeFormat
 */
export enum TimeFormat {
  /**
   * @generated from enum value: TIME_FORMAT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TIME_FORMAT_UA = 1;
   */
  UA = 1,

  /**
   * @generated from enum value: TIME_FORMAT_TZ = 2;
   */
  TZ = 2,

  /**
   * @generated from enum value: TIME_FORMAT_UTC = 3;
   */
  UTC = 3,
}

/**
 * Describes the enum common.TimeFormat.
 */
export const TimeFormatSchema: GenEnum<TimeFormat> = /*@__PURE__*/
  enumDesc(file_common_user, 2);

/**
 * @generated from enum common.TwoFactorType
 */
export enum TwoFactorType {
  /**
   * @generated from enum value: TWO_FACTOR_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TWO_FACTOR_TYPE_SIGN_IN = 1;
   */
  SIGN_IN = 1,

  /**
   * @generated from enum value: TWO_FACTOR_TYPE_CHANGE_PASSWORD = 2;
   */
  CHANGE_PASSWORD = 2,
}

/**
 * Describes the enum common.TwoFactorType.
 */
export const TwoFactorTypeSchema: GenEnum<TwoFactorType> = /*@__PURE__*/
  enumDesc(file_common_user, 3);

/**
 * @generated from enum common.TwoFactorProvider
 */
export enum TwoFactorProvider {
  /**
   * @generated from enum value: TWO_FACTOR_PROVIDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TWO_FACTOR_PROVIDER_EMAIL = 1;
   */
  EMAIL = 1,
}

/**
 * Describes the enum common.TwoFactorProvider.
 */
export const TwoFactorProviderSchema: GenEnum<TwoFactorProvider> = /*@__PURE__*/
  enumDesc(file_common_user, 4);

/**
 * @generated from enum common.KycStatus
 */
export enum KycStatus {
  /**
   * @generated from enum value: KYC_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: KYC_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: KYC_STATUS_APPROVED = 2;
   */
  APPROVED = 2,

  /**
   * @generated from enum value: KYC_STATUS_DECLINED = 3;
   */
  DECLINED = 3,
}

/**
 * Describes the enum common.KycStatus.
 */
export const KycStatusSchema: GenEnum<KycStatus> = /*@__PURE__*/
  enumDesc(file_common_user, 5);

/**
 * @generated from enum common.OnboardingStatus
 */
export enum OnboardingStatus {
  /**
   * @generated from enum value: ONBOARDING_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ONBOARDING_STATUS_NOT_STARTED = 1;
   */
  NOT_STARTED = 1,

  /**
   * @generated from enum value: ONBOARDING_STATUS_IN_PROGRESS = 2;
   */
  IN_PROGRESS = 2,

  /**
   * @generated from enum value: ONBOARDING_STATUS_SKIPPED = 3;
   */
  SKIPPED = 3,

  /**
   * @generated from enum value: ONBOARDING_STATUS_COMPLETED = 4;
   */
  COMPLETED = 4,
}

/**
 * Describes the enum common.OnboardingStatus.
 */
export const OnboardingStatusSchema: GenEnum<OnboardingStatus> = /*@__PURE__*/
  enumDesc(file_common_user, 6);

